export default {
  first_name: 'Имя',
  last_name: 'Фамилия',
  patronymic_name: 'Отчество',
  birthdate: 'Дата рождения',
  gender: 'Пол',
  country: 'Страна проживания',
  city: 'Город проживания',
  address: 'Адрес проживания на латинице (используется для доставки техники)',
  address__hint: 'Страна, город, улица, дом и квартира',
  address_postcode: 'Индекс',
  equipment_recipient: 'ФИО получателя техники на латинице',
  phone: 'Телефон',
  phone__hint: 'Доступный номер телефона для связи c курьером',
  telegram: 'Telegram',
  telegram__hint:
    '@username или ссылка t.me/username. Если Telegram нет — укажи другой удобный мессенджер',
  contact_other: 'Дополнительный контакт для оперативной связи',
  contact_other__hint: 'Ссылка на мессенджер или личная почта',
  caption_emergency: 'Экстренные контакты',
  caption_emergency__hintAbove:
    'Нам важно быть готовыми оперативно помочь в экстренных ситуациях. Просим указать минимум ' +
    'один экстренный контакт, с которым мы сможем связаться, если возникнут чрезвычайные ' +
    'обстоятельства или потеряется связь с тобой на длительное время.',
  emergency_primary: 'Экстренный контакт (основной)',
  emergency_primary__hint:
    'ФИ, кем приходится, телефон и/или мессенджер. ' +
    'Например: Иванова Мария, мама, +7 900 000-00-00, @maria',
  emergency_current_location: 'Экстренный контакт (в текущей локации)',
  emergency_current_location__hint:
    'По желанию — тот, кто рядом с тобой в текущем городе/стране. ' +
    'Формат тот же: ФИ, кем приходится, телефон и/или мессенджер',
  caption_emergency__hintBelow:
    'Отправляя анкету, ты подтверждаешь, что уведомил(а) указанных экстренных контактных лиц ' +
    'о том, что их персональные данные (имя, степень родства, контактная информация) будут ' +
    'надёжно храниться и использоваться исключительно в экстренных ситуациях, и получил(а) ' +
    'их согласие на такое использование.',
  // ОРГАНИЗАЦИОННЫЕ ВОПРОСЫ
  contacts: 'Контакты',
  type_work: 'Предпочитаемый формат работы',
  type_work__hint: 'офис актуально, только если в твоем городе есть офис компании',
  office: 'Выбери офис из твоего города?',
  office__hintBelow:
    'На время карантина, новички приступают к работе удаленно, ' +
    'после снятия ограничений, появится возможность выйти в офис.',
  // ТЕХНИКА
  caption_technics: 'Вопросы по технике',
  caption_technics__hintAbove: `
    Компания обеспечивает каждого сотрудника рабочим оборудованием (один комплект на одного сотрудника). <br /><br />
    Мы не запрещаем использование личного оборудования, но настоятельно рекомендуем для работы использовать
    корпоративную технику с установленным антивирусом и последними обновлениями.
    Это крайне важно для закрытия уязвимостей, предотвращения угроз и соответствия требованиям Compliance. <br /><br />
    Доставка техники в некоторые локации может быть затруднена и занимать длительное время.
    Поэтому, пожалуйста, ответь в форме ниже, есть ли у тебя личная техника, с которой ты можешь начать работу.
  `,
  need_hardware: 'Есть ли у тебя личная техника с которой ты можешь начать работу?',
  need_hardware__hint:
    'Иногда доставка техники может задерживаться, поэтому она может не успеть прибыть к твоему первому рабочему дню',
  existing_hardware: 'Введи характеристики своего ноутбука/ПК',
  needed_hardware: 'Желаемая ОС ноутбука и периферия для работы',
  needed_hardware__hint: `Пожалуйста, укажи ниже, на какой операционной системе тебе будет комфортнее работать — <b>MacOS</b> или <b>Windows</b>. Также отметь, если тебе дополнительно потребуется периферия (<b>мышка</b>, <b>монитор</b>, <b>клавиатура</b> и т. п.).<br />
     <b>Обращаем внимание</b>, что в некоторых командах используется только одна ОС – мы предоставим технику по внутренним требованиям, даже если она будет отличаться от твоего запроса. Мы сообщим тебе, какую технику ты получишь, после заполнения анкеты.`,
  has_hardware:
    'Есть ли у тебя техника, на которой ты сможешь начать работу, пока мы доставляем оборудование от компании?',
  hardware_spec: 'Какие характеристики у твоего оборудования для работы?',
  hardware_spec__hint:
    'Характеристики ПК/ноутбука и версия ОС - мы проверим, достаточно ли производительности оборудования для выполнения рабочих задач',
};
